import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ContractESP from "./ContractESP";
import {
  setAppError,
  setBreadCrumb,
} from "../../../../../../../store/userSlice";
import { axios } from "../../../../../../../Global";
import LoadingWithLable from "../../../../../../../ReusableComponents/Loading/LoadingWithLable";

const ContractCPCostSheetAddNew = ({
  selectDatas,
  quotationId,
  updateCostSheetForm,
}) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { breadCrumbs } = useSelector((state) => state.user);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [FINAL_BODY, SET_FINAL_BODY] = useState([]);
  const params = useParams();
  const contractId = params.contractId;
  useEffect(() => {
    // Check if the "EDIT COST SHEET" breadcrumb is already in the array
    const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
      (crumb) => crumb.label === "ADD NEW COST SHEET"
    );

    if (!isEditCostSheetInBreadcrumbs) {
      dispatch(
        setBreadCrumb([
          ...breadCrumbs,
          { label: "ADD NEW COST SHEET", link: `` },
        ])
      );
    }
  }, [location.pathname, selectDatas, contractId]);

  const handleSubmit = (e) => {
    setSubmitLoading(true);
    e.preventDefault();
    const body = FINAL_BODY;
    axios
      .put(`/dashboard/contract-cost-sheet-add-new/${contractId}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "Successfully created.",
            color: "success",
          })
        );
        navigate(`/dashboard/contract/${contractId}`, {
          state: { detailType: "COST SHEET" },
        });
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <ContractESP selectDatas={selectDatas} SET_FINAL_BODY={SET_FINAL_BODY} />
      <button
        type="submit"
        className="bg-red rounded-md p-2 px-4 w-full max-w-xs text-white absolute left-1/2 mt-10 cursor-pointer text-sm"
        disabled={submitLoading}
      >
        {submitLoading ? (
          <LoadingWithLable className={"!mt-0 text-white "} />
        ) : (
          `SUBMIT`
        )}
      </button>
    </form>
  );
};

export default ContractCPCostSheetAddNew;
